<template>
  <div class="info-order" v-if="order">
    <!-- content 1 -->
    <div class="first-session">
      <!-- header -->
      <div class="header-card">
        <div class="img-title">
          <img src="../../assets/images/Boat-rental.svg" alt="boat-rental" />
        </div>
        <div class="info-boat">
          <p>Sport Boat | #: {{ order.order_info.boat_serial }} |</p>
          <img class="ml-2 img-people" src="../../assets/images/people.svg" alt="people" />
          <p class="ml-2">{{ order.boat_info.num_of_people }}</p>
        </div>
      </div>

      <!-- content -->
      <div class="content-card">
        <div class="order-card pb-4">
          <p class="title-card pt-4 pb-4">
            Order info
          </p>
          <div class="mt-2">
            <p>Order info Confirm #: {{ orderId }}</p>
            <p>Reserved: {{ formatOrderDateTime(order.order_info.order_time) }}</p>
            <p>
              <a target="_blank" class="contract-link" :href="order.order_info.contract_doc">
                Contract signed
              </a> at {{ formatOrderDateTime(order.order_info.contract_doc_signed_at) }}
            </p>
          </div>
          <div class="mt-2">
            <p>Rental period</p>
            <p>Start: {{ formatOrderDateTime(order.order_info.rent_time) }}</p>
            <p>End: {{ formatOrderDateTime(order.order_info.return_time) }} </p>
          </div>
        </div>
        <div class="footer-card pl-0 mb-3" v-if="order.order_info.order_status === 2">
          <div class="col-md-6">
            <datepicker v-if="isChangingOrderDate" ref="datePicker" placeholder="mm/dd/yyyy"
                        :disabledDates="disabledDates"
                        v-model="changeOrderDate"
                        :format="customFormatter"
                        @input="getRentalBoatAvailableDays"
                        class="form-control date" id="date" name="startdate">
            </datepicker>
            <button class="button-client mt-3" @click="toggleChangeOrderDate">
              <p v-if="!isChangingOrderDate">Edit</p>
              <p v-if="isChangingOrderDate">Close</p>
            </button>
          </div>
        </div>
        <hr>
        <div class="order-card">
          <p class="title-card pt-4 pb-4">
            User info
          </p>
          <div class="mt-2">
            <p>Full name: {{ order.user_info.full_name }}</p>
            <p>Email: {{ order.user_info.email }}</p>
            <p>Phone: {{ order.user_info.phone_number }}</p>
            <p>Emergency Phone: {{ order.user_info.emergency_phone_number }}</p>
          </div>
        </div>
      </div>

      <!-- footer -->
      <div class="footer-card">
        <button class="button-client" @click="onPopupTextClient">
          <p>Text client</p>
        </button>
      </div>
    </div>

    <!-- content 2 -->
    <div class="second-session">
      <div class="status" :style="'border-color: ' + (typeof orderStatusColor[order.order_info.order_status_name.toLowerCase()] !== 'undefined' ? orderStatusColor[order.order_info.order_status_name.toLowerCase()] : orderStatusColor['new'] )">
        <p>Order Status</p>
        <hr>
        <p class="text-status">
          <span :style="'color: ' + (typeof orderStatusColor[order.order_info.order_status_name.toLowerCase()] !== 'undefined' ? orderStatusColor[order.order_info.order_status_name.toLowerCase()] : orderStatusColor['new'] )">
              {{ order.order_info.order_status_name }}
          </span>
        </p>
      </div>
    </div>

    <modal-text-client
      v-if="order && order.order_info && isTextSmsClientModal"
      :order-id="order && order.order_info.order_id"
      @close="isTextSmsClientModal = false"
      @send="onClientSmsTextSuccess"
    />
  </div>
</template>

<script>
import DibbleJS from "@/dibble";
import DibbleAPI from "@/api";
import DibbleApi from "@/api";
import ModalTextClient from "@/components/Rental/OrderPage/ModalTextClient";
import {EventBus} from "@/utils/event-bus";
import Datepicker from "vuejs-datepicker";

export default {
  name: "InfoOrder",
  components: { ModalTextClient, Datepicker },
  data() {
    return {
      dibbleJs: DibbleJS,
      isChangingOrderDate: false,
      isOrderDateInitCompleted: false,
      changeOrderDate: new Date(),
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      orderStatusColor: {
        'new': '#1C5169',
        'pending': '#FC9C2B',
        'in the water': '#2C94AB',
        'done': '#6ac847',
        'closed': '#6ac847',
        'cancelled': '#DC3444',
      },
      orderId: this.$route.params.id,
      order: null,
      isTextSmsClientModal: false
    };
  },
  created() {
    EventBus.$emit("currentViewOrderId", this.orderId);
    this.loadOrderInfo()

    // For payment fallback return
    if (this.$route.query.info) {
      try {
        this.callbackInfo = JSON.parse(atob(this.$route.query.info))
      } catch (e) {
        this.callbackInfo = {rc: 500, message: "Invalid payment response. Unknown Error!"}
      }

      if (this.callbackInfo.rc === 0) {
        this.dibbleJs.toastSuccessMessage("Payment is success.")
      } else {
        this.dibbleJs.toastErrorMessage(this.callbackInfo['message'])
      }
    }
  },
  methods: {
    getRentalBoatAvailableDays() {
      const params = {
        request: DibbleAPI.api.getRentalBoatAvailableDays,
        boat_type: this.order.boat_info.boat_type,
        start_date: this.$moment(this.changeOrderDate).format('YYYY-MM-DD'),
      }
      DibbleJS.showLoader();
      DibbleJS.callApiRequest(params, (response) => {
        DibbleJS.hideLoader();
        if (response.rc === 0) {
          const numOfAvailableBoats = response.num_of_available_boats;
          if (numOfAvailableBoats > 0) {
            if (numOfAvailableBoats === 1) {
              DibbleJS.confirmBox("Are you sure you want to change the reservation's date to " + this.$moment(this.changeOrderDate).format('MM-DD-YYYY') + "?", () => {
                  this.updateOrderDate()
              })
            }
          } else {
            this.dibbleJs.toastErrorMessage("There is no available boat for this date.")
          }
        } else {
          this.dibbleJs.toastErrorMessage(response.message)
        }
      }, this._onLoadOrderFailed)
    },
    updateOrderDate() {
      const params = {
        request: DibbleAPI.api.changeRentalOrderDate,
        order_id: this.order.order_info.order_id,
        new_date: this.$moment(this.changeOrderDate).format('YYYY-MM-DD'),
      }
      DibbleJS.showLoader();
      DibbleJS.callApiRequest(params, (response) => {
          DibbleJS.hideLoader() 
          if (response.rc === 0) {
            this.dibbleJs.toastSuccessMessage("Order date is changed successfully.")
            this.loadOrderInfo()
          } else {
            this.dibbleJs.toastErrorMessage(response.message)
            this.changeOrderDate = new Date(this.order.order_info.rent_time)
          }
      }, this._onLoadOrderFailed)
    },
    loadOrderInfo() {
      const params = {
        request: DibbleAPI.api.adminGetRentalBoatOrder,
        order_id: this.orderId
      }
      DibbleJS.showLoader();
      DibbleJS.callApiRequest(params, this._onLoadOrderSuccess, this._onLoadOrderFailed)
    },
    _onLoadOrderSuccess(response) {
      DibbleJS.hideLoader();
      if (DibbleApi.isResponseSuccess(response)) {
        this.order = this.orderOrigin = response;
        this.changeOrderDate = this.$moment(this.order.order_info.rent_time).toDate();
        this.isOrderDateInitCompleted = true;
      } else {
        DibbleJS.toastErrorMessage(response.message)
      }
    },
    _onLoadOrderFailed() {
      DibbleJS.hideLoader();
      DibbleJS.toastErrorMessage('Something wrong! can not load data');
    },
    formatOrderDateTime(dateStr) {
      return this.$moment(dateStr, 'YYYY-MM-DD hh:mm:ss').format("MM/DD/YYYY hh:mm");
    },
    onPopupTextClient() {
      this.isTextSmsClientModal = true;
    },
    onClientSmsTextSuccess() {
      this.isTextSmsClientModal = false;
      this.loadOrderInfo();
    },
    customFormatter(date) {
      return this.$moment(date).format("MM/DD/YYYY");
    },
    toggleChangeOrderDate() {
      this.changeOrderDate = new Date(this.order.order_info.rent_time)
      this.isChangingOrderDate = !this.isChangingOrderDate;
    },
  }
};
</script>

<style lang="scss" scoped>
.info-order {
  margin: 20px 70px;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  min-width: 600px;
  .first-session {
    flex-basis: 50%;
    border-radius: 40px;
    background: #f3f6f7;
    box-shadow: 0px 15px 20px -6px rgba(16, 24, 40, 0.15);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .header-card {
      background: #c2d8dd;
      box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
      border-radius: 40px;
      height: 95px;
      display: flex;
      flex-direction: column;
      padding: 20px;
      .img-title {
        height: 30px;
        img {
          width: 50px;
        }
      }
      .img-people {
        width: 20px;
      }
      .info-boat {
        display: flex;
        flex: 1;
        p {
          font-family: "Roboto";
          font-style: normal;
          font-weight: 500;
          font-size: 24px;
          line-height: 24px;
          letter-spacing: 0.02em;
          color: #555e67;
        }
      }
    }
    .content-card {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 20px;
      .order-card {
        flex: 1 1;
        &:nth-child(1) {
          flex: 1.5 1;
        }
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .title-card {
          color: #2C94AB ;
          font-weight: 700;
          margin-bottom: 0px;
        }
        p {
          font-family: 'Open Sans';
          font-style: normal;
          font-size: 24px;
          line-height: 24px;
          color: #555E67;
          margin-bottom: 10px;
        }
        a {
          color: #555E67;
        }
      }
      hr {
        width: 100%;
        height: 1.5px;
        background: #DEE6EA;
        border: none;
        margin: 0;
      }
    }
    .footer-card {
      height: 100px;
      padding-left: 20px;
      .button-client {
        border-radius: 100px;
        width: 200px;
        height: 60px;
        background: #1C5169;
        box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
        user-select: none;
        border: none;
        p {
          font-family: 'Open Sans';
          font-style: normal;
          font-weight: 600;
          font-size: 20px;
          color: #FFFFFF;
        }
      }
    }
  }
  .second-session {
    flex: 1 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Open Sans';
    font-style: normal;
    .status {
      border: 12px solid #6CA779;
      border-radius: 100%;
      background: #E8EFF1;
      height: 150px;
      width: 150px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 15px;
      user-select: none;
      .text-status {
        color: #6CA779;
      }
      p {
        font-size: 20px;
        color: #555E67;
        text-transform: capitalize;
        text-align: center;
        font-weight: 600;
      }
      hr {
        width: 100%;
        height: 1.5px;
        background: #DEE6EA;
        margin: 0;
      }

    }
  }
}
@media only screen and (min-width: 701px) and (max-width: 1400px) {
  .first-session {
    flex-basis: 75% !important;
    p {
      font-size: 20px !important;
    }
  }
  .second-session {
    .status {
      margin-left: 20px;
    }
  }
}
@media only screen and (max-width: 700px) {
  .info-order {
    flex-direction: column !important;
    margin: 20px 40px !important;
  }
  .first-session {
    width: 100% !important;
    p {
      font-size: 16px !important;
    }
  }
  .second-session {
      margin-top: 20px !important;
    }
}
</style>
